interface GallerySectionProps {
  onWhatsAppClick: () => void;
}

export default function GallerySection({ onWhatsAppClick }: GallerySectionProps) {
  return (
    <section id="galeria" className="py-16 bg-gradient-to-br from-gray-100 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">DJ Jean em Ação</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Veja o profissionalismo e a energia do DJ Jean em diferentes eventos
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="relative group">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <img 
                alt="DJ Jean profissional" 
                className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-500" 
                src="https://static.readdy.ai/image/0179d60eb192a4383e7134d41ff99ed6/7d6b09c68d9e496bb53f1e2a68a910cd.jfif"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <h3 className="text-xl font-bold mb-1">Profissionalismo</h3>
                <p className="text-sm text-gray-200">Equipamentos de última geração</p>
              </div>
            </div>
          </div>
          
          <div className="relative group">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <img 
                alt="DJ Jean na balada" 
                className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-500" 
                src="https://static.readdy.ai/image/0179d60eb192a4383e7134d41ff99ed6/b8cc38bb0cff21ea2e63f0abcd9f0dfd.jfif"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 text-white">
                <h3 className="text-xl font-bold mb-1">Energia da Balada</h3>
                <p className="text-sm text-gray-200">Atmosfera única e inesquecível</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-10">
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-2xl max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-3">🎵 DJ Jean: Experiência e Qualidade 🎵</h3>
            <p className="text-base text-gray-700 mb-4 leading-relaxed">
              Com anos de experiência no mercado de eventos, DJ Jean combina profissionalismo, equipamentos de primeira linha e muita energia para transformar sua festa em um momento único.
            </p>
            <div className="flex justify-center">
              <button 
                onClick={onWhatsAppClick}
                className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-6 py-3 rounded-full text-base font-bold transition-all transform hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap flex items-center"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Falar com DJ Jean
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}